export const CONSENT_COOKIE = 'idukki_consent'
export const CONSENT_VERSION = 2
export const CONSENT_EVENT = 'idukki:consent:change'

export type ConsentCategories = {
  necessary: true
  analytics: boolean
  marketing: boolean
  personalization: boolean
  functional: boolean
}

export type StoredConsent = {
  categories: ConsentCategories
  decidedAt: string
  version: number
}

export const DEFAULT_DENIED: ConsentCategories = {
  necessary: true,
  analytics: false,
  marketing: false,
  personalization: false,
  functional: false,
}

export const ALL_ACCEPTED: ConsentCategories = {
  necessary: true,
  analytics: true,
  marketing: true,
  personalization: true,
  functional: true,
}

// Effective categories before the user makes a choice. Functional
// (live chat / support tools) is treated as borderline-necessary so
// the chat widget loads on first visit; ad/analytics pixels stay off.
export const PRE_DECISION_DEFAULTS: ConsentCategories = {
  necessary: true,
  analytics: false,
  marketing: false,
  personalization: false,
  functional: true,
}
